import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import Button from "../../extra/Button";
import Input from "../../extra/Input";
import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import {
  createShippingMethod,
  updateShippingMethod,
} from "../../store/shippingMethod/shippingMethod.action";
import { getDefaultCurrency } from "../../store/currency/currency.action";

const ShippingMethodDialog = (props) => {
  const { dialogueData } = useSelector((state) => state.dialogue);
  const { defaultCurrency } = useSelector((state) => state.currency);
  const dispatch = useDispatch();

  const [mongoId, setMongoId] = useState(0);
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [cost, setCost] = useState("");
  const [duration, setDuration] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [error, setError] = useState({
    name: "",
    type: "",
    cost: "",
    duration: "",
  });

  useEffect(() => {
    dispatch(getDefaultCurrency());
  }, [dispatch]);

  useEffect(() => {
    if (dialogueData) {
      setMongoId(dialogueData._id);
      setName(dialogueData.name || "");
      setType(dialogueData.type || "");
      setCost(dialogueData.cost ?? "");
      setDuration(dialogueData.duration || "");
      setIsActive(dialogueData.isActive !== undefined ? dialogueData.isActive : true);
    }
  }, [dialogueData]);

  // Suggest common names based on type
  const nameSuggestions =
    type === "overseas"
      ? ["Air", "Sea", "Express"]
      : type === "domestic"
      ? ["Standard", "Expedite", "Same Day"]
      : [];

  const handleSubmit = () => {
    const parsedCost = parseFloat(cost);

    let validationError = {};
    if (!type) validationError.type = "Shipping type is required!";
    if (!name) validationError.name = "Shipping name is required!";
    if (cost === "" || cost === undefined) {
      validationError.cost = "Cost is required!";
    } else if (isNaN(parsedCost) || parsedCost < 0) {
      validationError.cost = "Enter a valid cost!";
    }
    if (!duration) validationError.duration = "Duration is required!";

    if (Object.keys(validationError).length > 0) {
      return setError(validationError);
    }

    const data = {
      name,
      type,
      cost: parsedCost,
      duration,
      isActive,
    };

    if (mongoId) {
      props.updateShippingMethod(data, mongoId);
    } else {
      props.createShippingMethod(data);
    }

    dispatch({ type: CLOSE_DIALOGUE });
  };

  return (
    <div className="mainDialogue fade-in">
      <div className="Dialogue">
        <div className="dialogueHeader">
          <div className="headerTitle fw-bold text-white">
            {mongoId ? "Edit" : "Add"} Shipping Method
          </div>
          <div
            className="closeBtn"
            onClick={() => dispatch({ type: CLOSE_DIALOGUE })}
          >
            <i className="fa-solid fa-xmark"></i>
          </div>
        </div>

        <div className="dialogueMain">
          {/* Type Selection */}
          <div className="row">
            <div className="col-12" style={{ marginBottom: "10px" }}>
              <label
                className="styleForTitle mb-2"
                style={{ color: "#000", fontSize: "14px" }}
              >
                Shipping Type
              </label>
              <select
                className="form-control form-control-line"
                value={type}
                onChange={(e) => {
                  setType(e.target.value);
                  setError({ ...error, type: "" });
                }}
              >
                <option value="" disabled>
                  --select type--
                </option>
                <option value="domestic">Domestic</option>
                <option value="overseas">Overseas</option>
              </select>
              {error.type && <p className="errorMessage">{error.type}</p>}
            </div>
          </div>

          {/* Name Input */}
          <div className="row">
            <div className="col-12" style={{ marginBottom: "10px" }}>
              <label
                className="styleForTitle mb-2"
                style={{ color: "#000", fontSize: "14px" }}
              >
                Shipping Name
              </label>
              <input
                className="form-control form-control-line"
                list="namesuggestions"
                value={name}
                placeholder="e.g. Standard, Air, Expedite"
                disabled={!type}
                onChange={(e) => {
                  setName(e.target.value);
                  setError({ ...error, name: "" });
                }}
              />
              <datalist id="namesuggestions">
                {nameSuggestions.map((opt) => (
                  <option key={opt} value={opt} />
                ))}
              </datalist>
              {error.name && <p className="errorMessage">{error.name}</p>}
            </div>
          </div>

          {/* Cost & Duration */}
          <div className="row">
            <div className="col-6">
              <Input
                label={`Cost (${defaultCurrency?.symbol || ''})`}
                id="cost"
                type="number"
                value={cost}
                placeholder="Enter cost..."
                errorMessage={error.cost}
                onChange={(e) => {
                  setCost(e.target.value);
                  setError({ ...error, cost: "" });
                }}
              />
            </div>
            <div className="col-6">
              <Input
                label="Duration"
                id="duration"
                type="text"
                value={duration}
                placeholder="e.g. 5-7 business days"
                errorMessage={error.duration}
                onChange={(e) => {
                  setDuration(e.target.value);
                  setError({ ...error, duration: "" });
                }}
              />
            </div>
          </div>

          {/* Active Toggle (only for edit) */}
          {mongoId ? (
            <div className="row">
              <div className="col-12" style={{ marginBottom: "10px" }}>
                <label
                  className="styleForTitle mb-2"
                  style={{ color: "#000", fontSize: "14px" }}
                >
                  Status
                </label>
                <select
                  className="form-control form-control-line"
                  value={isActive ? "true" : "false"}
                  onChange={(e) => setIsActive(e.target.value === "true")}
                >
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
                </select>
              </div>
            </div>
          ) : null}
        </div>

        <div className="dialogueFooter">
          <div className="dialogueBtn">
            <Button
              btnName="Submit"
              btnColor="btnBlackPrime text-light"
              style={{ borderRadius: "5px", width: "80px" }}
              newClass="me-2"
              onClick={handleSubmit}
            />
            <Button
              btnName="Close"
              btnColor="myCustomButton"
              style={{ borderRadius: "5px", width: "80px" }}
              onClick={() => dispatch({ type: CLOSE_DIALOGUE })}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { createShippingMethod, updateShippingMethod })(
  ShippingMethodDialog
);
